<div class="login-container">
    <div class="login-content">
        <div class="brand-header">
            <img src="assets/images/logo.png" class="brand-logo" alt="Ryno logo" />
        </div>

        <div class="registration-card">
            <div class="form-flow-container">

                <div *ngIf="currentScreen === 1">
                    <h2 class="welcome-text">Create Your Account</h2>
                    <p class="welcome-subtext">Request access. Fill in your details to get started.</p>

                    <form class="login-form" [formGroup]="registrationForm">

                        <div class="form-group">
                            <label for="username">Username</label>
                            <input class="form-control" type="text" formControlName="username" placeholder="Enter Username" />
                            <div *ngIf="registrationForm.get('username')?.invalid && (registrationForm.get('username')?.dirty || registrationForm.get('username')?.touched)" class="error-message">
                                <div *ngIf="registrationForm.get('username')?.errors?.['required']">Username is required.</div>
                                <div *ngIf="registrationForm.get('username')?.errors?.['minlength']">Username must be at least 4
                                    characters.</div>
                                <div *ngIf="registrationForm.get('username')?.errors?.['pattern']">Username must be alphanumeric.</div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="email">Email</label>
                            <input class="form-control" type="email" formControlName="email" placeholder="Enter email address" />
                            <div *ngIf="registrationForm.get('email')?.invalid && (registrationForm.get('email')?.dirty || registrationForm.get('email')?.touched)" class="error-message">
                                <div *ngIf="registrationForm.get('email')?.errors?.['required']">Email is required.</div>
                                <div *ngIf="registrationForm.get('email')?.errors?.['email']">Enter a valid email address.</div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="mobileNumber">Mobile Number</label>
                            <div class="phone-input-group">
                                <select class="country-select" [(ngModel)]="selectedCountryCode" [ngModelOptions]="{standalone: true}">
                                    <option *ngFor="let country of countries" [value]="country.dialCode">
                                        {{ country.flag }} {{ country.dialCode }}
                                    </option>
                                </select>
                                <input class="form-control phone-input" type="tel" formControlName="mobileNumber" placeholder="Enter Mobile Number" />
                            </div>
                            <div *ngIf="registrationForm.get('mobileNumber')?.invalid && (registrationForm.get('mobileNumber')?.dirty || registrationForm.get('mobileNumber')?.touched)" class="error-message">
                                <div *ngIf="registrationForm.get('mobileNumber')?.errors?.['required']">Mobile Number is required.</div>
                                <div *ngIf="registrationForm.get('mobileNumber')?.errors?.['pattern']">Enter a valid mobile number (4-15
                                    digits).</div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="password">Password</label>
                            <div class="password-input">
                                <input class="form-control" [type]="showPassword ? 'text' : 'password'" formControlName="password" placeholder="••••••••" />
                                <button class="password-toggle" type="button" (click)="togglePassword()">
                                    <svg *ngIf="!showPassword" width="20" height="20" viewBox="0 0 24 24">
                                        <path fill="currentColor" d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                                    </svg>
                                    <svg *ngIf="showPassword" width="20" height="20" viewBox="0 0 24 24">
                                        <path fill="currentColor" d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />
                                    </svg>
                                </button>
                            </div>
                            <div *ngIf="registrationForm.get('password')?.invalid && (registrationForm.get('password')?.dirty || registrationForm.get('password')?.touched)" class="error-message">
                                <div *ngIf="registrationForm.get('password')?.errors?.['required']">Password is required.</div>
                                <div *ngIf="registrationForm.get('password')?.errors?.['minlength']">Password must be at least 8
                                    characters.</div>
                                <div *ngIf="registrationForm.get('password')?.errors?.['pattern']">
                                    Password must include at least one uppercase letter, one lowercase letter, one number, and one special
                                    character.
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="confirmPassword">Confirm Password</label>
                            <div class="password-input">
                                <input class="form-control" [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword" placeholder="••••••••" />
                                <button class="password-toggle" type="button" (click)="toggleConfirmPassword()">
                                    <svg *ngIf="!showConfirmPassword" width="20" height="20" viewBox="0 0 24 24">
                                        <path fill="currentColor" d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                                    </svg>
                                    <svg *ngIf="showConfirmPassword" width="20" height="20" viewBox="0 0 24 24">
                                        <path fill="currentColor" d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />
                                    </svg>
                                </button>
                            </div>
                            <div *ngIf="registrationForm.get('confirmPassword')?.invalid && (registrationForm.get('confirmPassword')?.dirty || registrationForm.get('confirmPassword')?.touched)" class="error-message">
                                <div *ngIf="registrationForm.get('confirmPassword')?.errors?.['required']">Confirm Password is required.
                                </div>
                                <div *ngIf="registrationForm.get('confirmPassword')?.errors?.['passwordMismatch']">Passwords do not match.
                                </div>
                            </div>
                        </div>

                        <button type="button" (click)="nextScreen()" class="login-button register-button-override" [disabled]="isSubmitting">
                            {{ isSubmitting ? 'Processing...' : 'Verify & Register Now' }}
                        </button>

                        <div class="register-link-wrapper">
                            <p class="text-light">
                                Already have an account?
                                <a routerLink="/login" class="register-link text-primary">
                                    Log In
                                </a>
                            </p>
                        </div>
                    </form>
                </div>

                <div *ngIf="currentScreen === 2">
                    <h2 class="welcome-text">Verify your Mobile Number</h2>

                    <form class="login-form otp-form-custom" [formGroup]="otpForm">

                        <h3 class="otp-inner-title">Enter OTP</h3>

                        <p class="otp-instruction-text-custom text-light">
                            Enter the **4-digit OTP** sent to your registered mobile number.
                        </p>

                        <div class="form-group otp-input-group-custom">
                            <div class="otp-input-boxes">
                                <input class="otp-box" type="text" formControlName="digit1" maxlength="1" #d1 (input)="autoFocusNext($event, d2)" />
                                <span class="otp-separator">-</span>
                                <input class="otp-box" type="text" formControlName="digit2" maxlength="1" #d2 (input)="autoFocusNext($event, d3)" />
                                <span class="otp-separator">-</span>
                                <input class="otp-box" type="text" formControlName="digit3" maxlength="1" #d3 (input)="autoFocusNext($event, d4)" />
                                <span class="otp-separator">-</span>
                                <input class="otp-box" type="text" formControlName="digit4" maxlength="1" #d4 />
                            </div>
                            <div *ngIf="otpForm.invalid && otpForm.touched" class="error-message">
                                Please enter all 4 digits of the OTP.
                            </div>
                        </div>

                        <p class="otp-timer-text text-light d-none">
                            Code Expires in: 01:00
                        </p>

                        <button type="button" (click)="nextScreen()" class="login-button register-button-override verify-btn-custom" [disabled]="otpForm.invalid || isSubmitting">
                            {{ isSubmitting ? 'Verifying...' : 'Verify' }}
                        </button>

                        <div class="resend-link-wrapper-custom">
                            <span class="text-light"> Didn't receive code? </span>
                            <a (click)="!isSubmitting && resendOtp()" class="resend-link-custom" [class.disabled-link]="isSubmitting">Resend OTP</a>
                        </div>
                    </form>
                </div>

                <div *ngIf="currentScreen === 3">
                    <div class="login-form final-screen-content">

                        <div class="success-icon-wrapper">
                            <svg width="70" height="70" viewBox="0 0 24 24">
                                <path fill="#5CB85C" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9.5l-8 8z" />
                            </svg>
                        </div>

                        <h2 class="welcome-text final-title">Registration Complete !</h2>

                        <p class="final-instruction-text text-light">
                            Your account is under review. You will be notified once the admin approves your registration.
                        </p>

                        <div class="review-details">
                            <p class="text-light"><svg width="20" height="20" viewBox="0 0 24 24">
                                    <path fill="#5CB85C" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.25 14.25l-4.5-4.5V7h2v4.25l4.5 4.5-1.41 1.41z" />
                                </svg> Verification typically takes 24-48 hours
                            </p>
                            <p class="text-light"><svg width="20" height="20" viewBox="0 0 24 24">
                                    <path fill="#5CB85C" d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z" />
                                </svg> You'll receive an SMS once your account is approved.</p>
                        </div>

                        <a routerLink="/login" class="login-button register-button-override final-btn-custom">
                            <svg width="20" height="20" viewBox="0 0 24 24" style="margin-right: 0.5rem;">
                                <path fill="currentColor" d="M13.41 18.59L8.83 14H20v-2H8.83l4.58-4.59L12 7l-6 6 6 6 1.41-1.41z" />
                            </svg> Back to Login
                        </a>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>